<template>
  <component
    :is="to ? 'router-link' : 'a'"
    v-bind="linkProps"
    class="btnSvg"
    :class="variant === 'gold' ? 'btnSvgGold' : 'btnSvgRed'"
  >
    <span v-if="sublabel" class="btnLine1">{{ sublabel }}</span>
    <span class="btnLine2" :class="{ btnTextBlack: variant === 'gold' }">{{ label }}</span>
  </component>
</template>

<script>
export default {
  name: "ButtonPrimary",
  props: {
    variant: {
      type: String,
      default: "red",
      validator: (v) => ["red", "gold"].includes(v),
    },
    label: {
      type: String,
      required: true,
    },
    sublabel: {
      type: String,
      default: "",
    },
    to: {
      type: String,
      default: "",
    },
    href: {
      type: String,
      default: "#",
    },
    target: {
      type: String,
      default: "_self",
    },
  },
  computed: {
    linkProps() {
      if (this.to) return { to: this.to };
      return { href: this.href, target: this.target };
    },
  },
};
</script>

<style lang="scss" scoped>
.btnSvg {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 110px;
  border-radius: 10px;
  text-decoration: none;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  color: white;
  font-weight: 700;
  transition: opacity 0.2s, box-shadow 0.2s;

  &:hover {
    opacity: 0.88;
    color: white;
    text-decoration: none;
  }
}

.btnSvgRed {
  background-image: url("../assets/image/components/buttonRed.svg");
}

.btnSvgGold {
  background-image: url("../assets/image/components/buttonGold.svg");
}

.btnLine1 {
  font-size: 0.95rem;
  letter-spacing: 0.02em;
}


.btnLine2 {
  font-size: 1.05rem;
  background-color: rgba(215, 0, 0, 0.83);
  padding: 2px 6px;
  border-radius: 5px;
}

.btnTextBlack {
  color: black;
  background-color: rgba(255, 255, 255, 0.3);
  padding: 2px 6px;
  border-radius: 5px;
}
</style>
